import styled from 'styled-components';

export const FormTitle = styled.p`
  font-size: 14px;
  margin-bottom: 6px;
`;

export const SectionWrapper = styled.div`
  padding: 30px 0;
  &#reserveButton {
    @media screen and (max-width: 768px) {
      display: flex;
      justify-content: center;
    }
  }
  &#captchaWrapper {
    padding: 0;
  }
`;

export const BladeSubtitle = styled.h3`
  font-size: 18px;
  font-weight: normal;
  line-height: 1.6;
  margin-bottom: 20px;
  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;
